import { useState, useEffect, useRef } from 'react'

/**
 * useInView — fires once when element enters the viewport.
 * @param {number} threshold  0–1, portion of element visible before triggering
 * @param {string} rootMargin e.g. '-10% 0px -10% 0px'
 */
export default function useInView(threshold = 0.12, rootMargin = '0px') {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.unobserve(el)   // fire once only
        }
      },
      { threshold, rootMargin }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [threshold, rootMargin])

  return [ref, visible]
}
